import { HttpService } from "./https.service";
import { BASE_URL } from "../../config/config";
import { AutomationCompleteFormData, IgAutomationCompleteFormData, ExistingIgAutomation } from 'custom-type';

const http = new HttpService();

export class InstagramDMAutomation {
    async getInfluencerAccounts(data: {influencer_id: number, ig_id?: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/accounts`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInfluencerAccounts :: ${error}`);
        }
    }

    async connectInstagram(data: any) {
        try {
            const path = BASE_URL + `/influencer/instagram/connect`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`connectInstagram :: ${error}`);
        }
    }
    
    // Post medias of instagram account
    async getInstagramPostMedias(data: {connected_instagram_account_id: string; ig_access_token: string}) {
        try {
            const path = BASE_URL + `/influencer/instagram/getPostMedias`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInstagramPostMedias :: ${error}`);
        }
    }

    // Story medias of instagram account
    async getInstagramStoryMedias(data: {connected_instagram_account_id: string; ig_access_token: string}) {
        try {
            const path = BASE_URL + `/influencer/instagram/getStoryMedias`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getInstagramPostMedias :: ${error}`);
        }
    }

    // async automationSaveAsDraft(data: AutomationCompleteFormData) {
    //     try {
    //         const path = BASE_URL + `/influencer/instagram/automation/saveDraft`;
    //         const response = await http.postRequest(path, data, null);
    //         return response;
    //     } catch (error) {
    //         throw new Error(`automationSaveAsDraft :: ${error}`);
    //     }
    // }

    async automationSave(data: AutomationCompleteFormData) {
        try {
            const path = BASE_URL + `/influencer/instagram/automation/save`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`automationSave :: ${error}`);
        }
    }

    async automationUpdate(data: AutomationCompleteFormData) {
        try {
            const path = BASE_URL + `/influencer/instagram/automation/update`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`automationUpdate :: ${error}`);
        }
    }

    async getIgAutomations(data: {influencer_id: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getIgAutomations :: ${error}`);
        }
    }

    async getDraftAutomation(data: {influencer_id: number, ig_automation_id: string | number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/draft/automation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getDraftAutomation :: ${error}`);
        }
    }

    async deleteAutomation(data: any) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/deleteAutomation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`deleteAutomation :: ${error}`);
        }
    }

    async onOffAutomation(data: {ig_automation_id: number, status: string}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/onOffAutomation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`onOffAutomation :: ${error}`);
        }
    }

    // New design methods for saving and updating automations
    async igAutomationSave(data: IgAutomationCompleteFormData) {
        try {
            const path = BASE_URL + `/influencer/instagram/ig-automation/save`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`igAutomationSave :: ${error}`);
        }
    }

    async igAutomationUpdate(data: ExistingIgAutomation) {
        try {
            const path = BASE_URL + `/influencer/instagram/ig-automation/update`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`igAutomationUpdate :: ${error}`);
        }
    }
    
    async getIgAutomationsList(data: {account_id: number, influencer_id: number, user_id: number, brand_id: number, user_type: string, page: number, limit: number, getActiveAutomations: boolean}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/list`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getIgAutomations :: ${error}`);
        }
    }

    async getIgAutomationsPosts(data: {influencer_id: number, page: number, limit: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/posts/list`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getIgAutomationsPosts :: ${error}`);
        }
    }

    async getIgAutomationsActivities(data: {influencer_id: number, page: number, limit: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/activities`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getIgAutomations :: ${error}`);
        }
    }

    async igOnOffAutomation(
        data: {
            account_id: number | string,
            influencer_id: number | string,
            user_id: number | string,
            brand_id: number | string,
            user_type: 'Influencer' | 'Brand', 
            ig_automation_id: number, 
            is_active: boolean
        }
    ) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/igOnOffAutomation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`onOffAutomation :: ${error}`);
        }
    }

    async igOnOffAutomationPost(
        data: {
            account_id: number | string,
            influencer_id: number | string,
            user_id: number | string,
            brand_id: number | string,
            user_type: 'Influencer' | 'Brand',
            ig_automation_id: number, 
            ig_automation_post_id: number, 
            is_active: boolean
        }
    ) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/igOnOffAutomationPost`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`igOnOffAutomationPost :: ${error}`);
        }
    }

    async igDeleteAutomation(data: {ig_automation_id: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/igDeleteAutomation`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`igDeleteAutomation :: ${error}`);
        }
    }

    async igDeleteAutomationPost(data: {ig_automation_id: number, ig_automation_post_id: number}) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/igDeleteAutomationPost`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`igDeleteAutomation :: ${error}`);
        }
    }

    // Destinations offered for the Zap Link second button — the creator's own
    // storefront and link-in-bio, when they exist. Returns { suggestions: [] }
    // for a creator who has neither, in which case only a custom URL is offered.
    /** Renames one automation. Single column, scoped by influencer_id server-side. */
    async igRenameAutomation(data: { ig_automation_id: number | string, influencer_id: number | string, automation_name: string }) {
        try {
            const path = BASE_URL + `/influencer/instagram/automations/rename`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`igRenameAutomation :: ${error}`);
        }
    }

    async getZapCtaSuggestions(data: { influencer_id: number | string, account_id: number | string }) {
        try {
            const path = BASE_URL + `/influencer/instagram/zap-link/cta-suggestions`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`getZapCtaSuggestions :: ${error}`);
        }
    }

    async fetchZapLinkProduct(data: { product_url: string, allow_other_source: boolean }) {
        try {
            const path = BASE_URL + `/influencer/instagram/zap-link/fetch-product`;
            const response = await http.postRequest(path, data, null);
            return response;
        } catch (error) {
            throw new Error(`fetchZapLinkProduct :: ${error}`);
        }
    }

    // Influencer's own Zap Link analytics (owner-scoped)
    async getMyZapAnalytics(params: { influencer_id: number | string; start_date?: string; end_date?: string }) {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(
                    Object.entries(params)
                        .filter(([, v]) => v !== undefined && v !== '')
                        .map(([k, v]) => [k, String(v)])
                )
            ).toString();
            const path = BASE_URL + `/zap-flow/influencer/analytics${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getMyZapAnalytics :: ${error}`);
        }
    }

    // Influencer's own attributed Zap-link sales + commission earnings (owner-scoped)
    async getMyZapEarnings(params: { influencer_id: number | string; start_date?: string; end_date?: string }) {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(
                    Object.entries(params)
                        .filter(([, v]) => v !== undefined && v !== '')
                        .map(([k, v]) => [k, String(v)])
                )
            ).toString();
            const path = BASE_URL + `/zap-flow/influencer/earnings${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getMyZapEarnings :: ${error}`);
        }
    }

    // Per-automation Zap drill-down for the influencer's own automation (ownership-guarded server-side)
    async getMyAutomationZapTracking(params: { influencer_id: number | string; ig_automation_id: number | string; start_date?: string; end_date?: string }) {
        try {
            const qs = new URLSearchParams(
                Object.fromEntries(
                    Object.entries(params)
                        .filter(([, v]) => v !== undefined && v !== '')
                        .map(([k, v]) => [k, String(v)])
                )
            ).toString();
            const path = BASE_URL + `/zap-flow/influencer/automation-tracking${qs ? '?' + qs : ''}`;
            return await http.getRequest(path, null);
        } catch (error) {
            throw new Error(`getMyAutomationZapTracking :: ${error}`);
        }
    }
}